import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";

export function BreakingNewsBanner({ items = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
    if (items.length <= 1) return undefined;

    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % items.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [items]);

  if (!items.length) return null;
  const item = items[activeIndex] || items[0];

  return (
    <section
      className="flex-shrink-0 bg-[#D71920] text-white border-b border-[#A80F15]"
      role="alert"
      aria-live="polite"
      aria-label="Breaking news"
      data-testid="breaking-news-banner"
    >
      <div className="h-12 px-5 lg:px-8 flex items-center gap-4 min-w-0">
        <h2 className="text-xs font-black uppercase tracking-[0.16em] font-['Archivo'] flex-shrink-0">
          Breaking
        </h2>
        <a
          key={`${item.url}::${item.title}`}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-2 min-w-0 text-sm font-semibold leading-tight hover:underline focus:outline-none"
        >
          <span className="truncate whitespace-nowrap">{item.title}</span>
          <ExternalLink className="w-3.5 h-3.5 flex-shrink-0 opacity-70 group-hover:opacity-100" strokeWidth={1.75} />
        </a>
      </div>
    </section>
  );
}
